import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70218f20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchGroup" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }

import { ref, Ref, reactive, onActivated, nextTick } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import router from '@/router/index'
import { formatNumber, getNumber, formatFullTime } from '@/utils/index'
import CommissionList from '@/views/ViewsComponents/commissionModle/CommissionList.vue'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/commission/cost': fetchList,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const tabName = ref('cost')
const detailsEle = ref()
const searchEle = ref()
const searchObj = reactive({
  amList: '', pmList: '', cmList: '', share: '', customerName: '', orgId: '',
  orderNo: '', createdAt: [], deliverAt: [], closeAt: []
})
const searchHandle = () => {
  fetchData({
    ...searchObj,
    createDate: {from: searchObj.createdAt?.[0], to: searchObj.createdAt?.[1]},
    deliverDate: {from: searchObj.deliverAt?.[0], to: searchObj.deliverAt?.[1]},
    closeDate: {from: searchObj.closeAt?.[0], to: searchObj.closeAt?.[1]},
  })
}

onActivated(() => {
  if(router.currentRoute.value.query?.ids){
    tabName.value = 'details'
    // console.log(detailsEle.value);
    
    nextTick(() => {
      detailsEle.value.searchHandle()
    })
  }
})

// 展示外部成本
const isShowExternal = ref<boolean>(false)
const externalTable = ref([])
const showExteranl = (row: any) => {
  externalTable.value = row.externalCostList
  isShowExternal.value = true
}
// 展示内部成本
const isShowInternal = ref<boolean>(false)
const internalTable = ref([])
const showInternal = (row: any) => {
  internalTable.value = row.internalCostList
  isShowInternal.value = true

}

// 展示总提成
const isTotalCommission = ref<boolean>(false)
const TotalCommissionTable: any = ref([])
const showTotalCommission = (data: any) => {
  let row = data.commissionDetailVo
  TotalCommissionTable.value = [
    {...row, project: 'AM', commissionOwner: row.am, ratio: row.amRatio ? row.amRatio + '%' : '', commissionAmount: row.amAmount},
    {...row, project: 'PM', commissionOwner: row.pm, ratio: row.pmRatio ? row.pmRatio + '%' : '', commissionAmount: row.pmAmount},
    {...row, project: 'CM', commissionOwner: row.cm, ratio: row.cmRatio ? row.cmRatio + '%' : '', commissionAmount: row.cmAmount},
    {...row, project: 'share', commissionOwner: row.share, ratio: row.shareRatio ? row.shareRatio + '%' : '', commissionAmount: row.shareAmount},
    {...row, project: '销售补充', commissionOwner: row.owner, ratio: row.ownerRatio ? row.ownerRatio + '%' : '', commissionAmount: row.ownerAmount},
  ]
  isTotalCommission.value = true
}
const arraySpanMethod = ({ row, column, rowIndex, columnIndex }: any) => {
  if (![0, 5, 6, 7, 8, 9].includes(columnIndex)) return;
  if(rowIndex  % 5 === 0 ) return [5, 1];
  return [0, 0]
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, {
      type: "border-card",
      modelValue: tabName.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((tabName).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "订单成本明细表",
          name: "cost"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse_item, { title: "点此展开搜索" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      ref_key: "searchEle",
                      ref: searchEle,
                      model: _unref(searchObj),
                      "label-width": "auto",
                      inline: "",
                      class: "searchBg",
                      disabled: _unref(MI_identify)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "订单号:",
                          prop: "orderNo"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(searchObj).orderNo,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).orderNo) = $event)),
                              placeholder: "请输入订单号",
                              clearable: "",
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "创建时间:",
                          prop: "createdAt"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _unref(searchObj).createdAt,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).createdAt) = $event)),
                              type: "daterange",
                              "value-format": "YYYY-MM-DD",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "交付时间:",
                          prop: "deliverAt"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _unref(searchObj).deliverAt,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).deliverAt) = $event)),
                              type: "daterange",
                              "value-format": "YYYY-MM-DD",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "关闭时间:",
                          prop: "closeAt"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _unref(searchObj).closeAt,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchObj).closeAt) = $event)),
                              type: "daterange",
                              "value-format": "YYYY-MM-DD",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "客户:",
                          prop: "customerName"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _unref(searchObj).customerName,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchObj).customerName) = $event)),
                              placeholder: "请输入客户",
                              clearable: "",
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "团队:",
                          prop: "orgId"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _unref(searchObj).orgId,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchObj).orgId) = $event)),
                              placeholder: "请选择团队",
                              clearable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysOrganizations, (org) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    label: org.name,
                                    value: org.id,
                                    key: org.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_1, [
                          _createVNode(_component_el_form_item, {
                            label: "PM:",
                            prop: "pmList"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _unref(searchObj).pmList,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchObj).pmList) = $event)),
                                placeholder: "请选择PM",
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "collapse-tags": ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysUsers, (user) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: `${user.alias} (${user.realName})`,
                                      value: user.alias
                                    }, null, 8, ["label", "value"]))
                                  }), 256))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "CM:",
                            prop: "cmList"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _unref(searchObj).cmList,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchObj).cmList) = $event)),
                                placeholder: "请选择CM",
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "collapse-tags": ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysUsers, (user) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: `${user.alias} (${user.realName})`,
                                      value: user.alias
                                    }, null, 8, ["label", "value"]))
                                  }), 256))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "AM:",
                            prop: "amList"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _unref(searchObj).amList,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(searchObj).amList) = $event)),
                                placeholder: "请选择AM",
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                "collapse-tags": ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysUsers, (user) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: `${user.alias} (${user.realName})`,
                                      value: user.alias
                                    }, null, 8, ["label", "value"]))
                                  }), 256))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "SHARE:",
                            prop: "share"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _unref(searchObj).share,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(searchObj).share) = $event)),
                                placeholder: "请选择share",
                                clearable: "",
                                filterable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysUsers, (user) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: `${user.alias} (${user.realName})`,
                                      value: user.alias
                                    }, null, 8, ["label", "value"]))
                                  }), 256))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_el_form_item, { label: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (searchEle.value.resetFields()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (searchHandle()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_3
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _unref(MI_tableData),
              border: "",
              class: "mt-10",
              "max-height": _unref(MI_height)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "订单ID",
                  prop: "orderNo",
                  width: "125",
                  fixed: "",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "计算提成月份",
                  prop: "closeMonth",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  label: "原始币种",
                  prop: "currency",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  label: "销售金额",
                  prop: "amount",
                  width: "100",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "回款金额",
                  prop: "flowAmount",
                  width: "100",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "回款汇率",
                  prop: "flowRatio",
                  width: "100",
                  align: "right"
                }),
                _createVNode(_component_el_table_column, {
                  label: "RMB回款金额",
                  prop: "rmbAmount",
                  width: "110",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "外部成本",
                  prop: "externalCost",
                  width: "100",
                  align: "right"
                }, {
                  default: _withCtx(({row}) => [
                    (row.externalCost)
                      ? (_openBlock(), _createBlock(_component_el_link, {
                          key: 0,
                          type: "primary",
                          onClick: ($event: any) => (showExteranl(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(getNumber)(row.externalCost)), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(getNumber)(row.externalCost)), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "内部成本",
                  prop: "internalCost",
                  width: "100",
                  align: "right"
                }, {
                  default: _withCtx(({row}) => [
                    (row.internalCost)
                      ? (_openBlock(), _createBlock(_component_el_link, {
                          key: 0,
                          type: "primary",
                          onClick: ($event: any) => (showInternal(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(getNumber)(row.internalCost)), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(getNumber)(row.internalCost)), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "财务费用",
                  prop: "financialExpenses",
                  width: "100",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "手续费",
                  prop: "feeCo3",
                  align: "right",
                  width: "100",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "坏账",
                  prop: "badDebt",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "非翻译成本",
                  prop: "noTranslatorCost",
                  width: "100",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "毛利",
                  prop: "grossProfit",
                  align: "right",
                  width: "100",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "销售导师提成",
                  prop: "mentorCommission",
                  width: "105",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "总提成(点击)",
                  prop: "totalCommission",
                  width: "110",
                  align: "right",
                  fixed: "right"
                }, {
                  default: _withCtx(({row}) => [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: ($event: any) => (showTotalCommission(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getNumber)(row.totalCommission)), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"])), [
              [_directive_loading, _unref(MI_identify)]
            ]),
            _createVNode(_component_el_pagination, {
              background: "",
              small: "",
              class: "mt-10",
              disabled: _unref(MI_identify),
              total: _unref(MI_total),
              currentPage: _unref(page),
              "onUpdate:currentPage": _cache[12] || (_cache[12] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
              "page-size": _unref(size),
              "onUpdate:page-size": _cache[13] || (_cache[13] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
              "page-sizes": [30, 50, 100, 500],
              layout: "sizes, prev, pager, next, total, jumper",
              onCurrentChange: _unref(MI_pageChange),
              onSizeChange: _unref(MI_sizeChange)
            }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "订单提成明细表",
          name: "details"
        }, {
          default: _withCtx(() => [
            _createVNode(CommissionList, {
              ref_key: "detailsEle",
              ref: detailsEle
            }, null, 512)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowExternal.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((isShowExternal).value = $event)),
      title: "外部成本",
      width: "1000px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: externalTable.value,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "成本单ID",
              prop: "taskId"
            }),
            _createVNode(_component_el_table_column, {
              label: "译员ID",
              prop: "resourceId"
            }),
            _createVNode(_component_el_table_column, {
              label: "译员币种",
              prop: "resourceCurrency"
            }),
            _createVNode(_component_el_table_column, {
              label: "usd金额",
              prop: "amount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "rmb金额",
              prop: "rmbAmount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "余额时间",
              prop: "paymentTime",
              formatter: _unref(formatFullTime)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "余额时间汇率",
              prop: "paymentRatio",
              align: "right"
            }),
            _createVNode(_component_el_table_column, {
              label: "收款时间",
              prop: "flowTimes",
              formatter: _unref(formatFullTime)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "收款时间汇率",
              prop: "flowTimeRatio",
              align: "right"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowInternal.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((isShowInternal).value = $event)),
      title: "内部成本",
      width: "1000px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: internalTable.value,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "成本单ID",
              prop: "taskId"
            }),
            _createVNode(_component_el_table_column, {
              label: "译员ID",
              prop: "resourceId"
            }),
            _createVNode(_component_el_table_column, {
              label: "译员币种",
              prop: "resourceCurrency"
            }),
            _createVNode(_component_el_table_column, {
              label: "usd金额",
              prop: "amount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "rmb金额",
              prop: "rmbAmount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "余额时间",
              prop: "paymentTime",
              formatter: _unref(formatFullTime)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "余额时间汇率",
              prop: "paymentRatio",
              align: "right"
            }),
            _createVNode(_component_el_table_column, {
              label: "收款时间",
              prop: "flowTimes",
              formatter: _unref(formatFullTime)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "收款时间汇率",
              prop: "flowTimeRatio",
              align: "right"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isTotalCommission.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((isTotalCommission).value = $event)),
      title: "订单提成明细表",
      width: "1050px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          border: "",
          "span-method": arraySpanMethod,
          data: TotalCommissionTable.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "订单ID",
              prop: "orderNo",
              width: "130",
              fixed: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "提成项目",
              prop: "project"
            }),
            _createVNode(_component_el_table_column, {
              label: "提成人",
              prop: "commissionOwner"
            }),
            _createVNode(_component_el_table_column, {
              label: "提成率",
              prop: "ratio",
              align: "right"
            }),
            _createVNode(_component_el_table_column, {
              label: "提成金额",
              prop: "commissionAmount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "RMB回款金额",
              prop: "rmbAmount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "成本",
              prop: "cost",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "毛利",
              prop: "grossProfit",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "计算提成日期",
              prop: "closeMonth"
            }),
            _createVNode(_component_el_table_column, {
              label: "总提成",
              prop: "totalCommission",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})